import { useSearchParams } from '@remix-run/react'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Label } from '#app/components/ui/label'
import { RadioGroup, RadioGroupItem } from '#app/components/ui/radio-group'

const options = [
	{ value: 'popular', translationKey: 'product_list_page:most_popular' },
	{ value: 'new', translationKey: 'newest_tag' },
	{ value: 'price_asc', translationKey: 'lowest_price' },
	{ value: 'price_desc', translationKey: 'highest_price' },
	{ value: 'on_sale', translationKey: 'product_list_page:on_sale' },
]

const SortSelection = () => {
	const [searchParams, setParams] = useSearchParams()

	const initialSortOrder = searchParams.get('sortingOrder') || 'new'

	const [selectedSort, setSelectedSort] = useState(initialSortOrder)

	let { t } = useTranslation('search')

	useEffect(() => {
		const sortOrder = searchParams.get('sortingOrder') || 'new'
		setSelectedSort(sortOrder)
	}, [searchParams])

	const handleOnChange = (value: string) => {
		const newSearchParams = new URLSearchParams(searchParams)

		newSearchParams.set('sortingOrder', value)
		newSearchParams.delete('p')

		setParams(newSearchParams)
		setSelectedSort(value)
	}

	return (
		<RadioGroup className="space-y-2" value={selectedSort}>
			{options.map(({ value, translationKey }) => (
				<div className="flex items-center space-x-2" key={value}>
					<RadioGroupItem
						className="border-2 border-beige-50 bg-white text-black-90 aria-checked:border-black-90"
						value={value}
						id={value}
						onClick={() => handleOnChange(value)}
					/>
					<Label htmlFor={value}>{t(translationKey)}</Label>
				</div>
			))}
		</RadioGroup>
	)
}

export default SortSelection
